<template>
    <div>

        <c-panel v-if="editServidor && !dados.id">
            <div class="loading-form" style="min-height: 300px;">
                <img src="/public/img/loading-bar.gif" />
            </div>
        </c-panel>

        <el-form @submit.native.prevent="onSubmitServidor" v-if="!editServidor || dados.id" :model="dados" ref="dados" label-position="top">
            <div v-if="!editServidor || dados.id">

                <c-panel>
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="4" :md="4">
                            <el-form-item class="u-text-center" label="Foto do Servidor" prop="foto" key="foto">
                                <input-image v-model="fotoFile" :maxBytes="2097152" @erro="onFotoErro" @delete="onFotoDelete"></input-image>
                                <small class="u-text-muted" style="display:block; text-align:center;">PNG ou JPEG, até 2MB.</small>
                            </el-form-item>
                        </el-col>
                        <el-col v-if="!fotoFile && fotoUrl" :xs="24" :sm="4" :md="4">
                            <img :src="fotoUrl" style="max-width:120px; margin: 8px auto; display:block; border-radius: 4px;">
                        </el-col>
                        <el-col :xs="24" :sm="(!fotoFile && fotoUrl) ? 16 : 20" :md="(!fotoFile && fotoUrl) ? 16 : 20">
                            <el-row :gutter="10">
                                <el-col :xs="24" :sm="18" :md="18">
                                    <el-form-item label="Nome do Servidor" prop="nome" :rules="regras('nome')" key="nome">
                                        <el-input v-model="dados.nome" maxlength="191" v-on:blur="formatData('nome')"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :xs="24" :sm="6" :md="6">
                                    <el-form-item label="Data de Nascimento" prop="data_nascimento" :rules="regras('data_nascimento', [$dataBlur])" key="data_nascimento">
                                        <el-input v-model="dados.data_nascimento" maxlength="191" v-mask="'##/##/####'" v-on:blur="formatData('data_nascimento', 10)"></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row :gutter="10">
                                <el-col :xs="24" :sm="24" :md="24">
                                    <el-form-item label="Nome do Servidor no Censo" prop="nome_censo" :rules="regras('nome_censo')" key="nome_censo">
                                        <el-input v-model="dados.nome_censo" maxlength="191" v-on:blur="formatData('nome_censo')"></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row :gutter="10">
                                <el-col :xs="24" :sm="12" :md="12">
                                    <el-form-item label="Raça/Cor" prop="cor" :rules="regras('cor')" key="cor">
                                        <el-select v-model="dados.cor">
                                            <el-option
                                                v-for="raca in $store.state.racas"
                                                :key="raca.id"
                                                :label="raca.nome"
                                                :value="raca.cod_censo">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :xs="24" :sm="12" :md="12">
                                    <el-form-item label="Sexo" prop="sexo" :rules="regras('sexo')" key="sexo">
                                        <el-select v-model="dados.sexo">
                                            <el-option :key="0" label="MASCULINO" :value="0"></el-option>
                                            <el-option :key="1" label="FEMININO" :value="1"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-col>
                    </el-row>
                    

                    <!-- <el-row :gutter="10">
                        <el-col :xs="24" :sm="6" :md="6">
                            <el-form-item label="Cargo" prop="cargo" :rules="[$requiredChange]" key="cargo">
                                <el-select v-model="dados.cargo">
                                    <el-option v-for="(item, i) in $CONSTANTS.CARGO_SERVIDOR" :key="i" :label="item" :value="parseInt(i)"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="4" :md="4">
                            <el-form-item label="Data de Ingresso na Prefeitura" prop="data_ingresso_prefeitura" :rules="[$dataBlur]" key="data_ingresso_prefeitura">
                                <el-input v-model="dados.data_ingresso_prefeitura" maxlength="191" v-mask="'##/##/####'" v-on:blur="formatData('data_ingresso_prefeitura', 10)"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="4" :md="4" v-if="dados.situacao_funcional == 1">
                            <el-form-item label="Término do Contrato" prop="termino_contrato" :rules="[$requiredBlur, $dataBlur]" key="termino_contrato">
                                <el-input v-model="dados.termino_contrato" maxlength="191" v-mask="'##/##/####'" v-on:blur="formatData('termino_contrato', 10)"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="2" :md="2">
                            <el-form-item label="Lote" prop="lote" key="lote">
                                <el-input v-model="dados.lote" maxlength="191" v-on:blur="formatData('lote')"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="10" :md="10">
                            <el-form-item label="Matrícula" prop="matricula" key="matricula">
                                <el-input v-model="dados.matricula" maxlength="191" v-on:blur="formatData('matricula')"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row> -->

                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="24" :md="24">
                            <el-form-item label="Situação Funcional" prop="situacao_funcional" :rules="regras('situacao_funcional')" key="situacao_funcional">
                                <el-select v-model="dados.situacao_funcional">
                                    <el-option v-for="(item, i) in $CONSTANTS.SITUACAO_FUNCIONAL_SERVIDOR" :key="i" :label="item" :value="parseInt(i)"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="10" v-if="dados.escolaridade == 7">
                        <el-col :xs="24" :sm="24" :md="24">
                            <el-form-item label="Tipo de Ensino Médio Cursado*" prop="tipo_ensino_medio" :rules="[$requiredChange]" key="tipo_ensino_medio">
                                <el-select v-model="dados.tipo_ensino_medio">
                                    <el-option v-for="(item, i) in $CONSTANTS.TIPO_ENSINO_MEDIO_SERVIDOR" :key="i" :label="item" :value="parseInt(i)"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="12" :md="12">
                            <el-form-item label="Filiação 1 (preferencialmente nome da mãe)" prop="mae" :rules="regras('mae')" key="mae">
                                <el-input v-model="dados.mae" maxlength="191" v-on:blur="formatData('mae')"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="12">
                            <el-form-item label="Filiação 2" prop="pai" :rules="regras('pai')" key="pai">
                                <el-input v-model="dados.pai" maxlength="191" v-on:blur="formatData('pai')"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="6" :md="6">
                            <el-form-item label="Telefone" prop="telefone" :rules="regras('telefone')" key="telefone">
                                <el-input v-model="dados.telefone" maxlength="191" v-mask="'(##) ########'" v-on:blur="formatData('telefone', 13)"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="6" :md="6">
                            <el-form-item label="Celular" prop="celular" :rules="regras('celular')" key="celular">
                                <el-input v-model="dados.celular" maxlength="191" v-mask="'(##) #########'" v-on:blur="formatData('celular', 14)"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="6" :md="6">
                            <el-form-item label="Outro Celular" prop="celular_outro" :rules="regras('celular_outro')" key="celular_outro">
                                <el-input v-model="dados.celular_outro" maxlength="191" v-mask="'(##) #########'" v-on:blur="formatData('celular_outro', 14)"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="6" :md="6" class="reset-text-transform">
                            <el-form-item label="E-mail" prop="email" :rules="regras('email', [$emailBlur])" key="email">
                                <el-input v-model="dados.email" maxlength="191"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="24" :md="24">
                            <el-form-item label="Deficiência" prop="deficiencias" :rules="regras('deficiencias')" key="deficiencias">
                                <el-select v-model="dados.deficiencias" multiple>
                                    <el-option
                                        v-for="(item, i) in selectDeficiencias"
                                        :key="i"
                                        :label="item.nome"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="(dados.nacionalidade == 3) ? 12 : 24" :md="(dados.nacionalidade == 3) ? 12 : 24">
                            <el-form-item label="Nacionalidade" prop="nacionalidade" :rules="regras('nacionalidade')" key="nacionalidade">
                                <el-select @change="changeNacionalidade()" v-model="dados.nacionalidade">
                                    <el-option :key="1" label="BRASILEIRA" :value="1"></el-option>
                                    <el-option :key="2" label="BRASILEIRA - NASCIDO NO EXTERIOR OU NATURALIZADO" :value="2"></el-option>
                                    <el-option :key="3" label="ESTRANGEIRA" :value="3"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col v-if="dados.nacionalidade == 3" :xs="24" :sm="12" :md="12">
                            <el-form-item label="País de Nacionalidade*" prop="pais_id" :rules="[$requiredChange]" key="pais_id">
                                <el-select v-model="dados.pais_id" clearable>
                                    <el-option v-for="(pais, i) in paises" :key="i" :label="pais.nome" :value="pais.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10" v-if="dados.nacionalidade == 1">
                        <el-col :xs="24" :sm="24" :md="24">
                            <el-form-item label="Município de Nascimento*" prop="municipio_nascimento.nome" :rules="[$requiredBlur]" key="municipio_nascimento">
                                <el-input style="width: calc(100% - 55px); float: left" readonly v-model="dados.municipio_nascimento.nome" maxlength="191" class="readonly"></el-input>
                                <el-button style="float: right; width: 40px; height: 40px;" @click="showSearchMunNascimento" icon="el-icon-search" circle></el-button>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </c-panel>

                <c-panel title="ESCOLARIDADE">
                   
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="24" :md="24">
                            <el-form-item label="Maior nível de escolaridade Concluído" prop="escolaridade" :rules="regras('escolaridade')" key="escolaridade">
                                <el-select v-model="dados.escolaridade">
                                    <el-option v-for="(item, i) in $CONSTANTS.MAIOR_ESCOLARIDADE_SERVIDOR" :key="i" :label="item" :value="parseInt(i)"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <template  v-if="dados.escolaridade == 6">
                        <el-row :gutter="10" v-for="(item, i) in dados.pos_graduacao" :key="i">
                            <el-col :xs="24" :sm="8" :md="8" >
                                <el-form-item label="Tipo de pós-graduação" :prop="`pos_graduacao[${i}].tipo_pos_graduacao`" :rules="[$requiredChange]" key="tipo_pos_graduacao">
                                    <el-select v-model="dados.pos_graduacao[i].tipo_pos_graduacao" clearable>
                                        <el-option v-for="(item, i) in $CONSTANTS.POS_GRADUACAO_SERVIDOR" :key="i" :label="item" :value="i"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="24" :sm="11" :md="11">
                                <el-form-item label="Área da pós-graduação" :prop="`pos_graduacao[${i}].area_pos_graduacao`" :rules="[$requiredChange]" key="area_pos_graduacao">
                                    <el-select v-model="dados.pos_graduacao[i].area_pos_graduacao" clearable>
                                        <el-option v-for="(item, i) in $CONSTANTS.AREA_POS_GRADUACAO_SERVIDOR" :key="i" :label="item" :value="parseInt(i)"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="24" :sm="4" :md="4">
                                <el-form-item label="Ano de conclusão" :prop="`pos_graduacao[${i}].ano_pos_graduacao`" :rules="[$requiredBlur]" key="ano_pos_graduacao">
                                    <el-input v-model="dados.pos_graduacao[i].ano_pos_graduacao" maxlength="4" v-mask="'####'" v-on:blur="formatData('ano_inicio', 4)"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="24" :sm="1" :md="1" class="u-text-right">
                                <el-button @click="removeLinhaPos(i)" type="danger" plain style="margin-top: 21px;">
                                    <i class="fas fa-trash-alt"></i>
                                </el-button>
                            </el-col>
                        </el-row>
                        <div class="u-text-right" v-if="dados.pos_graduacao.length <= 5">
                            <el-button @click="adicionarLinhaPos()" type="primary" plain>
                                <i class="fas fa-plus"></i> ADICIONAR PÓS GRADUAÇÃO
                            </el-button>
                        </div>
                    </template>

                </c-panel>

                <c-panel title="DOCUMENTAÇÃO">
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="12" :md="12">
                            <el-form-item label="PIS/PASEP" prop="pis_pasep" :rules="regras('pis_pasep')" key="pis_pasep">
                                <el-input v-model="dados.pis_pasep" maxlength="191"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="12">
                            <el-form-item label="CPF" prop="cpf" :rules="regras('cpf')" key="cpf">
                                <el-input :disabled="editServidor && ![4, 5, 6].includes(Number($store.state.user.tipo))" v-model="dados.cpf" maxlength="191" v-mask="'###.###.###-##'" v-on:blur="formatData('cpf', 14)"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="6" :md="6">
                            <el-form-item label="RG" prop="rg" :rules="regras('rg')" key="rg">
                                <el-input v-model="dados.rg" maxlength="191"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="6" :md="6">
                            <el-form-item label="Data de Emissão" prop="data_emissao_rg" :rules="regras('data_emissao_rg')" key="data_emissao_rg">
                                <el-input v-model="dados.data_emissao_rg" maxlength="191" v-mask="'##/##/####'" v-on:blur="formatData('data_emissao_rg', 10)"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="6" :md="6">
                            <el-form-item label="Orgão Emissor" prop="orgao_emissor_rg" :rules="regras('orgao_emissor_rg')" key="orgao_emissor_rg">
                                <el-input v-model="dados.orgao_emissor_rg" maxlength="191" v-on:blur="formatData('orgao_emissor_rg')"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="6" :md="6">
                            <el-form-item label="UF RG" prop="uf_rg" :rules="regras('uf_rg')" key="uf_rg">
                                <el-input v-model="dados.uf_rg" maxlength="191" v-on:blur="formatData('uf_rg')"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </c-panel>

                <c-panel title="ENDEREÇAMENTO">
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="4" :md="4">
                            <el-form-item label="CEP" prop="cep" :rules="regras('cep')" key="cep">
                                <el-input v-model="dados.cep" maxlength="191" v-mask="'#####-###'" :loading="buscandoCep" v-on:blur="buscarViaCep()"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="16" :md="16">
                            <el-form-item label="Logradouro" prop="logradouro" :rules="regras('logradouro')" key="logradouro">
                                <el-input v-model="dados.logradouro" maxlength="191"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="4" :md="4">
                            <el-form-item label="Número" prop="numero" :rules="regras('numero')" key="numero">
                                <el-input v-model="dados.numero" maxlength="191"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="8" :md="8">
                            <el-form-item label="Bairro" prop="bairro" :rules="regras('bairro')" key="bairro">
                                <el-input v-model="dados.bairro" maxlength="191"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="6" :md="6">
                            <el-form-item label="Complemento" prop="complemento" :rules="regras('complemento')" key="complemento">
                                <el-input v-model="dados.complemento" maxlength="191"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="(dados.localizacao_zona == 2) ? 4 : 10" :md="(dados.localizacao_zona == 2) ? 4 : 10">
                            <el-form-item label="Zona" prop="localizacao_zona" key="localizacao_zona" :rules="regras('localizacao_zona')">
                                <el-select v-model="dados.localizacao_zona">
                                    <el-option v-for="(item, i) in $CONSTANTS.LOCALIZACAO_ZONA" :key="i" :label="item" :value="parseInt(i)"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="6" :md="6" v-if="dados.localizacao_zona == 2">
                            <el-form-item label="Localização Diferenciada" prop="localizacao_diferenciada" key="localizacao_diferenciada">
                                <el-select v-model="dados.localizacao_diferenciada">
                                    <el-option :key="1" label="ÁREA DE ASSENTAMENTO" :value="1"></el-option>
                                    <el-option :key="2" label="TERRA INDÍGENA" :value="2"></el-option>
                                    <el-option :key="3" label="COMUNIDADE QUILOMBOLA" :value="3"></el-option>
                                    <el-option :key="7" label="NÃO ESTÁ EM ÁREA DE LOCALIZAÇÃO DIFERENCIADA" :value="7"></el-option>
                                    <el-option :key="8" label="ÁREA ONDE SE LOCALIZAM POVOS E COMUNIDADES TRADICIONAIS" :value="8"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="24" :md="24">
                            <el-form-item label="Cidade / Estado" prop="cidade.nome" :rules="regras('cidade')" key="cidade">
                                <el-input readonly v-model="dados.cidade.nome" maxlength="191" class="readonly"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </c-panel>

                <el-tabs type="border-card" v-model="tabAtivo">

                    <el-tab-pane name="lotacao" label="LOTAÇÃO">
                        <el-form>
                            <el-row :gutter="10">
                                <!-- <el-col :xs="24" :sm="20" :md="20" v-if="editServidor">
                                    <el-form-item label="Data">
                                        <el-date-picker @change="getLotacoes" v-model="filtro.data_lotacao" type="date" placeholder="Pesquisar por data" format="dd/MM/yyyy" value-format="yyyy-MM-dd"> </el-date-picker>
                                    </el-form-item>
                                </el-col>
                                (editServidor) ? 4 : 24
                                -->
                                <el-col :xs="24" :sm="24" :md="24" class="u-text-right">
                                    <el-button type="primary" @click="showDialogLotacao(null)">CRIAR LOTAÇÃO</el-button>
                                </el-col>
                            </el-row>
                        </el-form>
                        <div class="container-table">
                            <table v-loading="loadingLotacoes" class="table table-striped">
                                <thead>
                                    <tr>
                                        <th class="hidden-mobile" style="width: 70px;">cod</th>
                                        <th>Instituição</th>
                                        <th v-if="editServidor" class="u-text-center">Dt. Lotação</th>
                                        <th v-if="editServidor" class="u-text-center">Dt. Remoção</th>
                                        <th v-if="editServidor" class="u-text-center">Função</th>
                                        <th style="width: 150px;" class="u-text-center">Ação</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, i) in ((editServidor) ? lotacoes : this.dados.lotacoes)" :key="i">
                                        <td class="hidden-mobile">{{ (item.id) ? item.id : '-' }}</td>
                                        <td>{{ (editServidor) ? item.instituicao.nome : (($store.state.user.tipo <= 3) ? $store.state.config.instituicao.nome : $store.state.instituicoes[item.instituicao_id].nome) }}</td>
                                        <td class="u-text-center" v-if="editServidor">
                                            {{ (item.data_lotacao) ? $moment(item.data_lotacao).format('DD/MM/YYYY') : '-' }}
                                        </td>
                                        <td class="u-text-center" v-if="editServidor">
                                            {{ (item.data_remocao) ? $moment(item.data_remocao).format('DD/MM/YYYY') : '-' }}
                                        </td>
                                        <td v-if="editServidor" class="u-text-center">{{ (item.funcao) ? $store.getters.mapaFuncaoServidor[item.funcao] : '-' }}</td>
                                        <td class="u-text-center acao">
                                            <el-button v-if="editServidor && !item.data_remocao" type="info" title="Editar" icon="el-icon-edit" size="mini" @click="showDialogLotacao(item)"></el-button>
                                            <el-button v-if="editServidor && !item.data_remocao" type="danger" title="REMOÇÃO DE SERVIDOR" icon="el-icon-remove-outline" size="mini" @click="showDialogRemocao(item.id)"></el-button>
                                            <el-button v-if="!editServidor && !item.data_remocao" type="danger" title="APAGAR REGISTRO" icon="el-icon-delete" size="mini" @click="removerLotacao(i)"></el-button>
                                        </td>
                                    </tr>
                                </tbody>
                                <tfoot>
                                    <tr v-if="!loadingLotacoes && lotacoes.length == 0" style="border-top: 1px solid #ddd;">
                                        <td colspan="100%" class="u-text-center">
                                            <span>- nenhum registro -</span>
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </el-tab-pane>

                    <el-tab-pane name="formacao" label="FORMAÇÃO SUPERIOR" v-if="editServidor && dados.escolaridade == 6">

                        <el-row :gutter="10" v-if="$store.state.user.tipo <= 1 || $store.state.user.tipo == 6 || $store.state.user.tipo == 8">
                            <el-col :xs="24" :sm="24" :md="24" class="u-text-right">
                                <el-button type="primary" @click="showDialogFormacao(null)">NOVA FORMAÇÃO SUPERIOR</el-button>
                            </el-col>
                        </el-row>
                        <div class="container-table">
                            <table v-loading="loadingFormacao" class="table table-striped">
                                <thead>
                                    <tr>
                                        <th>Nome da Instituição</th>
                                        <th>Curso</th>
                                        <th class="u-text-center">Situação</th>
                                        <th v-if="$store.state.user.tipo <= 1 || $store.state.user.tipo == 6 || $store.state.user.tipo == 8" style="width: 150px;" class="u-text-center">Ação</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, i) in formacao" :key="i">
                                        <td>{{ item.ensino_superior_instituicao ? item.ensino_superior_instituicao.nome : '-' }}</td>
                                        <td>{{ item.ensino_superior_curso ? item.ensino_superior_curso.nome : '-' }}</td>
                                        <td class="u-text-center">{{ (item.ano_conclusao) ? 'Concluída (' + item.ano_conclusao + ')'  : 'Em Andamento' }}</td>
                                        <td v-if="$store.state.user.tipo <= 1 || $store.state.user.tipo == 6 || $store.state.user.tipo == 8" class="u-text-center acao">

                                            <el-button @click="showDialogFormacao(item)" type="info" title="Editar" icon="el-icon-edit" size="mini"></el-button>
                                            <el-button @click="deleteFormacao(item.id)" type="danger" title="APAGAR REGISTRO" icon="el-icon-delete" size="mini"></el-button>
                                        </td>
                                    </tr>
                                </tbody>
                                <tfoot>
                                    <tr v-if="!loadingFormacao && formacao.length == 0" style="border-top: 1px solid #ddd;">
                                        <td colspan="100%" class="u-text-center">
                                            <span>- nenhum registro -</span>
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>

                    </el-tab-pane>

                    <el-tab-pane name="cursos" label="OUTROS CURSOS" v-if="editServidor && (dados.professor || dados.gestor)">

                        <el-row :gutter="10" v-if="$store.state.user.tipo <= 1 || $store.state.user.tipo == 6 || $store.state.user.tipo == 8">
                            <el-col :xs="24" :sm="24" :md="24" class="u-text-right">
                                <el-button type="primary" @click="showDialogCursosComplementares()">GERENCIAR CURSO FORMAÇÃO</el-button>
                            </el-col>
                        </el-row>
                        <div class="container-table">
                            <table v-loading="loadingCursosComplementares" class="table table-striped">
                                <thead>
                                    <tr>
                                        <th>Curso</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, i) in cursosComplementares" :key="i">
                                        <td>{{ item.nome }}</td>
                                    </tr>
                                </tbody>
                                <tfoot>
                                    <tr v-if="!loadingCursosComplementares && cursosComplementares.length == 0" style="border-top: 1px solid #ddd;">
                                        <td colspan="100%" class="u-text-center">
                                            <span>- nenhum registro -</span>
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>

                    </el-tab-pane>

                    <el-tab-pane name="disciplinas" label="DISCIPLINAS" v-if="editServidor && dados.professor">

                        <el-row :gutter="10">
                            <el-col :xs="24" :sm="24" :md="24" class="u-text-right">
                                <el-button type="primary" @click="showDialogDisciplina()" title="Cadastrar Nova Disciplina">GERENCIAR DISCIPLINAS</el-button>
                            </el-col>
                        </el-row>
                        <div class="container-table">
                            <table v-loading="loadingDisciplina" class="table table-striped">
                                <thead>
                                    <tr style="background-color: #ececec;">
                                        <th colspan="100%">Defina as disciplinas que {{ this.dados.nome }} está apto (a) a ministrar.</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, i) in disciplinasServidor" :key="i">
                                        <td>{{ item.nome_area }}</td>
                                    </tr>
                                </tbody>
                                <tfoot>
                                    <tr v-if="!loadingDisciplina && disciplinasServidor.length == 0" style="border-top: 1px solid #ddd;">
                                        <td colspan="100%" class="u-text-center">
                                            <span>- nenhum registro -</span>
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>

                    </el-tab-pane>

                    <el-tab-pane name="enturmacao" label="ENTURMAÇÃO" v-if="editServidor && dados.professor">

                        <el-row :gutter="10" v-if="[0, 1, 3, 12].includes(Number($store.state.user.tipo))">
                            <el-col :xs="24" :sm="24" :md="24" class="u-text-right">
                                <el-button type="primary" @click="showDialogEnturmacao(null)" style="margin-top: 25px;">NOVA ENTURMAÇÃO</el-button>
                            </el-col>
                        </el-row>
                        <div class="container-table">
                            <table v-loading="loadingEnturmacao" class="table table-striped">
                                <thead>
                                    <tr>
                                        <th>Instituição</th>
                                        <th>Curso</th>
                                        <th class="u-text-center">Turma</th>
                                        <th>Disciplina</th>
                                        <th v-if="[0, 1, 3, 12].includes(Number($store.state.user.tipo))" style="width: 150px;" class="u-text-center">Ação</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, i) in this.enturmacao" :key="i">
                                        <td>{{ item.instituicao.nome }}</td>
                                        <td>{{ item.curso }}</td>
                                        <td class="u-text-center">{{ item.turma.nome }}</td>
                                        <td>
                                            {{ (item.funcao == 2 ? $store.getters.mapaFuncaoServidor[item.funcao] : item.disciplina.nome) }}
                                        </td>
                                        <td v-if="[0, 1, 3, 12].includes(Number($store.state.user.tipo))" class="u-text-center acao">
                                            <el-button type="danger" title="APAGAR REGISTRO" icon="el-icon-delete" size="mini" @click="deleteEnturmacao(item)"></el-button>
                                        </td>
                                    </tr>
                                </tbody>
                                <tfoot>
                                    <tr v-if="!loadingEnturmacao && this.enturmacao.length == 0" style="border-top: 1px solid #ddd;">
                                        <td colspan="100%" class="u-text-center">
                                            <span>- nenhum registro -</span>
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>

                    </el-tab-pane>

                    <el-tab-pane name="anexos" label="ANEXOS">
                        <anexos ref="anexos" tipo="servidor" :id="dados.id"></anexos>
                    </el-tab-pane>

                </el-tabs>

                <div class="u-text-right u-mt-20">
                    <el-button type="primary" id="btn-servidor" native-type="submit">SALVAR</el-button>
                </div>

            </div>
        </el-form>

        <search-cidade
            key="searchCidade"
            v-on:close="searchCidade = false"
            :open="searchCidade"
            v-on:emitCidade="emitMunNascimento"
        ></search-cidade>

        <search-endereco
            key="searchEndereco"
            v-on:close="searchEndereco = false"
            :open="searchEndereco"
            v-on:emitEndereco="emitEndereco"
        ></search-endereco>

        <el-dialog :close-on-click-modal="false" title="GERENCIAR LOTAÇÃO DE SERVIDOR" :visible.sync="dialogLotacao" v-on:close="resetFormLotacao">
            <div v-if="dialogLotacao" style="margin-top: 20px;">

                <el-form @submit.native.prevent="onSubmitFormLotacao" :model="formLotacao" ref="formLotacao" label-position="top">
                    <div class="style-form u-mt-20">
                        <el-row :gutter="10">
                            <el-col :xs="24" :sm="24" :md="24">
                                <label>Servidor</label>
                                <div class="style-input readonly">{{ this.dados.nome }}</div>
                            </el-col>
                        </el-row>
                    </div>
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="24" :md="24">
                            <el-form-item label="Data da Lotação" prop="data_lotacao" :rules="[$requiredBlur, $dataBlur]" key="data_lotacao">
                                <el-input v-model="formLotacao.data_lotacao" maxlength="191" v-mask="'##/##/####'"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="24" :md="24">
                            <el-form-item label="Instituição" prop="instituicao_id" :rules="[$requiredChange]" key="instituicao_id">
                                <el-select v-model="formLotacao.instituicao_id" filterable placeholder="Pesquisar Instituição">
                                    <el-option v-for="(item, i) in instituicoesLotacao" :key="i" :label="item.nome" :value="item.id"> </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="24" :md="24">
                            <el-form-item label="Função ou Cargo" prop="funcao" :rules="[$requiredChange]" key="funcao">
                                <el-select v-model="formLotacao.funcao">
                                    <el-option v-for="(nome, codigo) in $store.getters.mapaFuncaoServidor" :key="codigo" :label="nome" :value="Number(codigo)"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="10" v-if="formLotacao.funcao == 11">
                        <el-col :xs="24" :sm="24" :md="24">
                            <el-form-item label="Critério de acesso ao Cargo/Função" prop="criterio_escolha_cargo" :rules="[$requiredChange]" key="criterio_escolha_cargo">
                                <el-select v-model="formLotacao.criterio_escolha_cargo">
                                    <!-- <el-option :key="1" label="SER PROPRIETÁRIO(A) OU SÓCIO(A)-PROPRIETÁRIO(A) DA ESCOLA" :value="1"></el-option> -->
                                    <el-option :key="2" label="EXCLUSIVAMENTE POR INDICAÇÃO/ESCOLHA DA GESTÃO" :value="2"></el-option>
                                    <!-- <el-option :key="3" label="PROCESSO SELETIVO QUALIFICADO E ESCOLHA/NOMEAÇÃO DA GESTÃO" :value="3"></el-option> -->
                                    <!-- <el-option :key="4" label="CONCURSO PÚBLICO ESPECÍFICO PARA O CARGO DE GESTOR ESCOLAR" :value="4"></el-option> -->
                                    <el-option :key="5" label="EXCLUSIVAMENTE POR PROCESSO ELEITORAL COM A PARTICIPAÇÃO DA COMUNIDADE ESCOLAR" :value="5"></el-option>
                                    <!-- <el-option :key="6" label="PROCESSO SELETIVO QUALIFICADO E ELEIÇÃO COM A PARTICIPAÇÃO DA COMUNIDADE ESCOLAR" :value="6"></el-option> -->
                                    <!-- <el-option :key="7" label="OUTROS" :value="7"></el-option> -->
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="24" :md="24">
                            <el-form-item label="Categoria" prop="categoria" key="categoria">
                                <el-input v-model="formLotacao.categoria" maxlength="191" clearable placeholder="Informe a categoria"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="24" :md="24">
                            <el-form-item label="Instituição Sede do Profissional" prop="instituicao_sede" key="instituicao_sede">
                                <el-input v-model="formLotacao.instituicao_sede" maxlength="191" placeholder="Informe a instituição sede do profissional"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="24" :md="24">
                            <el-form-item label="Observação" prop="observacao" key="observacao">
                                <el-input type="textarea" v-model="formLotacao.observacao"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :xs="24">
                            <el-form-item class="u-text-right u-mt-15">
                                <el-button type="primary" native-type="submit">SALVAR</el-button>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>

            </div>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" title="REMOVER SERVIDOR" width="30%" :visible.sync="dialogRemocao" v-on:close="resetFormRemocao">
            <div v-if="dialogRemocao" style="margin-top: 20px;">

                <el-form @submit.native.prevent="onSubmitFormRemocao" :model="formRemocao" ref="formRemocao" label-position="top">
                    <div class="style-form u-mt-20">
                        <el-row :gutter="10">
                            <el-col :xs="24" :sm="24" :md="24">
                                <label>Servidor</label>
                                <div class="style-input readonly">{{ this.dados.nome }}</div>
                            </el-col>
                        </el-row>
                    </div>
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="24" :md="24">
                            <el-form-item label="Data da Remoção" prop="data_remocao" :rules="[$requiredBlur, $dataBlur]" key="data_remocao">
                                <el-input v-model="formRemocao.data_remocao" maxlength="191" v-mask="'##/##/####'"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :xs="24">
                            <el-form-item class="u-text-right u-mt-15">
                                <el-button type="primary" native-type="submit">SALVAR</el-button>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>

            </div>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" title="ENTURMAÇÃO DE PROFESSOR" :visible.sync="dialogEnturmacao" v-on:close="resetFormEnturmacao">
            <div v-if="dialogEnturmacao" style="margin-top: 20px;">

                <el-form @submit.native.prevent="onSubmitFormEnturmacao" :model="formEnturmacao" ref="formEnturmacao" label-position="top">
                    <div class="style-form u-mt-20">
                        <el-row :gutter="10">
                            <el-col :xs="24" :sm="24" :md="24">
                                <label>Professor (a)</label>
                                <div class="style-input readonly">{{ this.dados.nome }}</div>
                            </el-col>
                        </el-row>
                    </div>
                    <el-row :gutter="10" v-if="lotacoesForEnturmacao.length > 1">
                        <el-col :xs="24" :sm="24" :md="24">
                            <el-form-item label="Função" prop="lotacao_id" :rules="[$requiredChange]" key="lotacao_id">
                                <el-select @change="changeLotacaoFormEnturmacao()" v-model="formEnturmacao.lotacao_id">
                                    <el-option v-for="(item, i) in lotacoesForEnturmacao" :key="i" :label="$store.getters.mapaFuncaoServidor[item.funcao]" :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="24" :md="24">
                            <el-form-item label="Tipo de Ensino" prop="tipo_ensino" :rules="[$requiredChange]" key="tipo_ensino">
                                <el-select  @change="changeTipoEnsino()" v-model="formEnturmacao.tipo_ensino">
                                    <el-option key="1" label="ENSINO REGULAR" :value="1"></el-option>
                                    <el-option v-if="formEnturmacao.lotacao_funcao != 3" key="2" label="ATENDIMENTO EDUCACIONAL ESPECIALIZADO" :value="2"></el-option>
                                    <el-option key="3" label="ATIVIDADE COMPLEMENTAR" :value="3"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="24" :md="24">
                            <el-form-item label="Turma" prop="turma_id" :rules="[$requiredChange]" key="turma_id">
                                <el-select v-model="formEnturmacao.turma_id" @change="turmaSelected()">
                                    <template v-if="formEnturmacao.tipo_ensino == 1">
                                        <el-option-group v-for="(curso, i) in turmas" :key="i" :label="i">
                                            <template v-for="item in curso">
                                                <el-option :key="item.id" :label="item.nome" :value="item.id"></el-option>
                                            </template>
                                        </el-option-group>
                                    </template>
                                    <template v-else>
                                        <el-option v-for="(item, i) in turmas" :key="i" :label="`TURMA: ${item.vagas_disponiveis}`" :value="item.id"></el-option>
                                    </template>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10" v-if="showAreasConhecimento">
                        <el-col :xs="24" :sm="24" :md="24">
                            <el-form-item label="Disciplina" prop="areas_conhecimento" :rules="[$requiredChange]" key="areas_conhecimento">
                                <el-select multiple v-model="formEnturmacao.areas_conhecimento">
                                    <el-option v-for="(item, i) in areas_conhecimento" :key="i" :label="item.nome_area" :value="parseInt(item.id)"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :xs="24">
                            <el-form-item class="u-text-right u-mt-15">
                                <el-button type="primary" native-type="submit">SALVAR</el-button>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
                
            </div>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" title="NOVA DISCIPLINA" :visible.sync="dialogDisciplina" v-on:close="resetFormDisciplina">
            <div v-if="dialogDisciplina" style="margin-top: 20px;">

                <el-form @submit.native.prevent="onSubmitFormDisciplina" :model="formDisciplina" ref="formDisciplina" label-position="top">
                    <div class="style-form u-mt-20">
                        <el-row :gutter="10">
                            <el-col :xs="24" :sm="24" :md="24">
                                <label>Servidor</label>
                                <div class="style-input readonly">{{ this.dados.nome }}</div>
                            </el-col>
                        </el-row>
                    </div>
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="24" :md="24">
                            <el-form-item label="Disciplinas" prop="disciplinas" key="disciplinas">
                                <el-select v-model="formDisciplina.disciplinas" filterable placeholder="Pesquisar Disciplinas" multiple>
                                    <template v-for="item in disciplinas">
                                        <el-option v-if="item.id != 46 && item.id != 50 && item.id != 55 && item.id != 88 && item.id != 99 && item.id != 100" :key="item.id" :label="item.nome_area" :value="item.id"> </el-option>
                                    </template>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :xs="24">
                            <el-form-item class="u-text-right u-mt-15">
                                <el-button type="primary" native-type="submit">SALVAR</el-button>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>

            </div>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" title="NOVA FORMAÇÃO" :visible.sync="dialogFormacao" v-on:close="resetFormFormacao">
            <div v-if="dialogFormacao" style="margin-top: 20px;">

                <el-form @submit.native.prevent="onSubmitFormFormacao" :model="formFormacao" ref="formFormacao" label-position="top">

                    <div class="style-form u-mt-20">
                        <el-row :gutter="10">
                            <el-col :xs="24" :sm="24" :md="24">
                                <label>Servidor</label>
                                <div class="style-input readonly">{{ this.dados.nome }}</div>
                            </el-col>
                        </el-row>
                    </div>
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="12" :md="12">
                            <el-form-item label="Ano Início" prop="ano_inicio" :rules="[$requiredBlur]" key="ano_inicio">
                                <el-input v-model="formFormacao.ano_inicio" maxlength="4" v-mask="'####'" v-on:blur="formatData('ano_inicio', 4)"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="12">
                            <el-form-item label="Ano de Conclusão" prop="ano_conclusao" :rules="[$requiredBlur]" key="ano_conclusao">
                                <el-input v-model="formFormacao.ano_conclusao" maxlength="4" v-mask="'####'" v-on:blur="formatData('ano_conclusao', 4)"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="24" :md="24">
                            <el-form-item label="Instituição Superior" prop="ensino_superior_instituicao_id" :rules="[$requiredChange]" key="ensino_superior_instituicao_id">
                                <el-select v-model="formFormacao.ensino_superior_instituicao_id" placeholder="pesquisar..." filterable remote :remote-method="searchInstituicaoSuperior" :loading="loadingInstituicaoSuperior">
                                    <el-option v-for="item in instituicoes" :key="item.id" :label="item.nome" :value="item.id"> </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="24" :md="24">
                            <el-form-item label="Curso Superior" prop="ensino_superior_curso_id" :rules="[$requiredChange]" key="ensino_superior_curso_id">
                                <el-select v-model="formFormacao.ensino_superior_curso_id" placeholder="pesquisar..." filterable remote :remote-method="searchCursoSuperior" :loading="loadingCursoSuperior">
                                    <el-option v-for="item in cursos" :key="item.id" :label="item.nome" :value="item.id"> </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="8" :md="8">
                            <el-form-item label="Situação" prop="situacao" key="situacao">
                                <el-select v-model="formFormacao.situacao" clearable placeholder="Selecione" style="width: 100%;">
                                    <el-option label="Concluída" value="Concluída"></el-option>
                                    <el-option label="Cursando" value="Cursando"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="8" :md="8">
                            <el-form-item label="Carga Horária" prop="carga_horaria" key="carga_horaria">
                                <el-input v-model="formFormacao.carga_horaria" maxlength="6" v-mask="'######'" placeholder="Horas"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="8" :md="8">
                            <el-form-item label="Número de Pontos" prop="numero_pontos" key="numero_pontos">
                                <el-input v-model="formFormacao.numero_pontos" maxlength="10"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="24" :md="24">
                            <el-form-item prop="complementacao" :rules="[$requiredBlur]" key="complementacao">
                                <el-checkbox v-model="formFormacao.complementacao">Formação/Complementação Pedagógica</el-checkbox>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :xs="24">
                            <el-form-item class="u-text-right u-mt-15">
                                <el-button type="primary" native-type="submit">SALVAR</el-button>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>

            </div>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" title="NOVO CURSO COMPLEMENTAR" :visible.sync="dialogCursosComplementares" v-on:close="resetFormCursoComplementar">
            <div v-if="dialogCursosComplementares" style="margin-top: 20px;">

                <el-form @submit.native.prevent="onSubmitFormCursosComplementares" :model="formCursosComplementares" ref="formCursosComplementares" label-position="top">
                    <div class="style-form u-mt-20">
                        <el-row :gutter="10">
                            <el-col :xs="24" :sm="24" :md="24">
                                <label>Servidor</label>
                                <div class="style-input readonly">{{ this.dados.nome }}</div>
                            </el-col>
                        </el-row>
                    </div>
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="24" :md="24">
                            <el-form-item label="Curso Complementar" prop="cursos" key="cursos">
                                <el-select v-model="formCursosComplementares.cursos" filterable placeholder="Pesquisar Curso Complementar" multiple>
                                    <el-option v-for="item in selectCursosComplementares" :key="item.id" :label="item.nome" :value="item.id"> </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :xs="24">
                            <el-form-item class="u-text-right u-mt-15">
                                <el-button type="primary" native-type="submit">SALVAR</el-button>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>

            </div>
        </el-dialog>

    </div>
</template>
<script>

import searchCidade from "@/components/search/search-cidade"
import searchEndereco from "@/components/search/search-endereco"
import anexos from "@/shared/anexos/anexos.vue"
import InputImage from '@/shared/input-image/input-image.vue'
import { CAMPOS_SERVIDOR, CHAVE_CAMPOS_SERVIDOR } from "@/shared/constants/camposObrigatorios"

export default {
    props: ['paramId'],
    data: () => ({
        camposObrigatorios: [],
        fotoFile: '',
        fotoUrl: '',
        buscandoCep: false,
        acentuacaoInstituicao: false,
        tabAtivo: 'lotacao',
        dialogRemocao: false,
        dialogLotacao: false,
        dialogEnturmacao: false,
        dialogDisciplina: false,
        dialogFormacao: false,
        dialogCursosComplementares: false,
        loadingLotacoes: false,
        loadingEnturmacao: false,
        loadingDisciplina: false,
        loadingFormacao: false,
        loadingInstituicaoSuperior: false,
        loadingCursoSuperior: false,
        loadingCursosComplementares: false,
        searchCidade: false,
        searchEndereco: false,
        editServidor: false,
        editLotacao: false,
        editFormacao: false,
        alert: false,
        dados: {
            id: '',
            nome: '',
            nome_censo: '',
            lote: '',
            matricula: '',
            tipo: '',
            cargo: '',
            professor: false,
            gestor: false,
            situacao_funcional: '',
            termino_contrato: '',
            inep: '',
            pis_pasep: '',
            rg: '',
            data_emissao_rg: '',
            orgao_emissor_rg: '',
            uf_rg: '',
            cpf: '',
            data_nascimento: '',
            mae: '',
            pai: '',
            sexo: '',
            cor: '',
            logradouro: '',
            numero: '',
            bairro: '',
            cep: '',
            complemento: '',
            localizacao_zona: '',
            nacionalidade: '',
            localizacao_diferenciada: '',
            email: '',
            telefone: '',
            celular: '',
            celular_outro: '',
            observacao: '',
            situacao: '',
            escolaridade: '',
            tipo_ensino_medio: '',
            tipo_ensino_cursado: '',
            data_ingresso_prefeitura: '',
            pais_id: '',
            municipio_nascimento_id: '',
            cidade_id: '',
            lotacoes: [],
            pos_graduacao: [],
            cidade: {
                id: '',
                nome: '',
                estado: {
                    id: '',
                    nome: ''
                }
            },
            pais: {
                id: '',
                nome: ''
            },
            municipio_nascimento: {
                id: '',
                nome: ''
            },
        },
        disciplinasServidor: [],
        formRemocao: {

            data_remocao: ''
        },
        formLotacao: {
            id: '',
            data_lotacao: '',
            observacao: '',
            instituicao_sede: '',
            instituicao_id: '',
            servidor_id: '',
            funcao: '',
            categoria: '',
            criterio_escolha_cargo: ''

        },
        formEnturmacao: {
            servidor_id: '',
            tipo_ensino: 1,
            referencia_nacional: '',
            turma_id: '',
            lotacao_id: '',
            lotacao_funcao: '',
            areas_conhecimento: [],
            periodo_letivo_id: ''
        },
        formDisciplina: {
            disciplinas: [],
            servidor_id: ''
        },
        formFormacao: {
            ano_inicio: '',
            ano_conclusao: '',
            situacao: '',
            carga_horaria: '',
            numero_pontos: '',
            complementacao: false,
            ensino_superior_curso_id: '',
            ensino_superior_instituicao_id: '',
            servidor_id: ''
        },
        formCursosComplementares: {
            cursos: [],
            servidor_id: ''
        },
        selectDeficiencias: [],
        lotacoes: [],
        enturmacao: [],
        areas_conhecimento: [],
        turmas: [],
        disciplinas: [],
        formacao: [],
        instituicoes: [],
        cursos: [],
        cursosComplementares: [],
        selectCursosComplementares: [],
        filtro: {
            data_lotacao: '',
            instituicao_id: '',
            servidor_id: ''
        },
        filtroEnturmacao:{
            periodo_letivo_id: '',
            instituicao_id: '',
            servidor_id: ''
        },
        instituicoesLotacao: [],
        lotacoesForEnturmacao: [],
        showAreasConhecimento: true

    }),
    mounted(){

        this.initFormServidor();
        this.carregarCamposObrigatorios();
        this.filtro.data_lotacao = this.$moment().format('YYYY-MM-DD');

        // Acentuação conforme a instituição ativa selecionada
        if(this.$store.state.config.instituicao && this.$store.state.config.instituicao.id)
            this.carregarAcentuacaoInstituicao(this.$store.state.config.instituicao.id);
    },
    methods:{

        uploadFotoIfNeeded(servidorId){
        //ENVIA A FOTO DO SERVIDOR (se selecionada) APÓS O CADASTRO/EDIÇÃO

            if(!this.fotoFile || !servidorId){ return Promise.resolve(); }

            const fd = new FormData();
            fd.append('foto', this.fotoFile);

            return this.$axios.post(
                `${this.$store.state.config.baseUrlApi}/api/servidor/uploadFoto/` + servidorId,
                fd,
                this.$store.getters.getHeaderFileAuth
            );
        },
        onFotoErro(msg){
            if(msg){ window.eventBus.$emit('alert', {msg, type: 'warning'}); }
        },
        onFotoDelete(){
        //REMOVE A FOTO (no backend se estiver editando e já houver foto salva)

            this.fotoFile = '';
            if(this.editServidor && this.dados.id && this.fotoUrl){
                this.$axios.delete(`${this.$store.state.config.baseUrlApi}/api/servidor/removerFoto/` + this.dados.id, this.$store.getters.getHeaderAuth).then(() => {
                    this.fotoUrl = '';
                }).catch((e) => { this.$store.commit('throwException', e); });
            }
        },

        // Carrega a lista global de campos obrigatórios (configurável em Configurações do Sistema).
        carregarCamposObrigatorios(){

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/parametro-sistema/getValor/${CHAVE_CAMPOS_SERVIDOR}`, this.$store.getters.getHeaderAuth)
                .then(r => {
                    const v = r.data && r.data.valor;
                    this.camposObrigatorios = Array.isArray(v) ? v : [];
                })
                .catch(() => { /* mantém vazio */ });
        },
        // Monta o array de regras de um campo: injeta 'required' se estiver configurado como obrigatório.
        regras(key, extras = []){

            const rules = Array.isArray(extras) ? extras.slice() : [];
            if(this.camposObrigatorios.includes(key)){
                const campo = CAMPOS_SERVIDOR.find(c => c.key === key);
                const trigger = (campo && campo.trigger) ? campo.trigger : 'blur';
                rules.unshift({ required: true, message: 'Campo obrigatório.', trigger });
            }
            return rules;
        },

        adicionarLinhaPos(){

            this.dados.pos_graduacao.push({ tipo_pos_graduacao: '', area_pos_graduacao: '', ano_pos_graduacao: '' });
        },

        removeLinhaPos(i){
            this.dados.pos_graduacao.splice(i, 1);
        },

        turmaSelected(){

            this.defineShowAreasConhecimento();
        },

        showDialogEnturmacao(){

            this.formEnturmacao = {
                servidor_id: '',
                tipo_ensino: 1,
                referencia_nacional: '',
                turma_id: '',
                lotacao_id: '',
                lotacao_funcao: '',
                areas_conhecimento: [],
                periodo_letivo_id: ''
            };

            this.showAreasConhecimento = true;            

            this.turmas = [];

            window.eventBus.$emit('loading', true);

            this.$axios.all([this.getDisciplinasByServidor(), this.getLotacaoForStoreEnturmacao()]).then(this.$axios.spread((disciplinas, lotacao)=>{

                window.eventBus.$emit('loading', false);

                if(lotacao.data.length == 0){

                    window.eventBus.$emit('alert', {msg: 'O servidor não está lotado em sua instituição. Você deverá realizar a lotação.', type: 'warning'});
                    return false;
                }

                this.getTurmas();

                if(lotacao.data.length == 1){
                    this.formEnturmacao.lotacao_id = lotacao.data[0].id;
                    this.formEnturmacao.lotacao_funcao = lotacao.data[0].funcao;
                }

                this.lotacoesForEnturmacao = lotacao.data;
                this.areas_conhecimento = disciplinas.data;

                this.dialogEnturmacao = true;

            })).catch((error) => { this.$store.commit('throwException', error); });


        },
        deleteFormacao(id){

            this.$msgbox.confirm('Tem certeza que deseja excluir esta formação?', 'Atenção', { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' }).then(() => {

                window.eventBus.$emit('loading', true);

                this.$axios.delete(`${this.$store.state.config.baseUrlApi}/api/servidor/deleteFormacao/` + id, this.$store.getters.getHeaderAuth).then(response => {

                    window.eventBus.$emit('loading', false);
                    window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                    this.getFormacao();
                    this.dialogInfoEvento = false;

                }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

            }).catch(()=>{});
        },
        getServidorById(id){

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/servidor/getById/` + id, this.$store.getters.getHeaderAuth).then(response => {

                if(response.data.data_nascimento)
                    response.data.data_nascimento = this.$moment(response.data.data_nascimento).format('DD/MM/YYYY');

                if(response.data.data_emissao_rg)
                    response.data.data_emissao_rg = this.$moment(response.data.data_emissao_rg).format('DD/MM/YYYY');

                if(response.data.data_ingresso_prefeitura)
                    response.data.data_ingresso_prefeitura = this.$moment(response.data.data_ingresso_prefeitura).format('DD/MM/YYYY');

                if(response.data.termino_contrato)
                    response.data.termino_contrato = this.$moment(response.data.termino_contrato).format('DD/MM/YYYY');

                this.dados = JSON.parse(JSON.stringify(response.data));
                this.fotoUrl = this.dados.foto_path ? `${this.$store.state.config.baseUrlApi}/storage/` + this.dados.foto_path : '';
                this.loadingDisciplina = true;

                this.getLotacoes();
                this.getEnturmacao();
                this.getFormacao();
                this.getCursosComplementares();
                this.getDisciplinasByServidor().then(response => {

                    this.loadingDisciplina = false;
                    this.disciplinasServidor = response.data;

                }).catch((error) => { this.$store.commit('throwException', error); });

            }).catch((error) => { this.$store.commit('throwException', error); });

        },
        changeTipoEnsino(){

            this.turmas = [];
            this.formEnturmacao.turma_id = '';
            this.formEnturmacao.referencia_nacional = '';
            this.formEnturmacao.areas_conhecimento = [];

            //SE FOR REGULAR
            if(this.formEnturmacao.tipo_ensino == 1){
                this.getTurmas();
            }

            //SE FOR ATENDIMENTO EDUCACIONAL ESPECIAL (AEE)
            if(this.formEnturmacao.tipo_ensino == 2){

                window.eventBus.$emit('loading', true);

                let i = this.$store.state.config.instituicao.id;
                let p = this.$store.state.config.periodo.id;

                this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/turma/getAllTurmasAee/${i}/${p}`, this.$store.getters.getHeaderAuth).then(response => {

                    this.turmas = response.data;
                    window.eventBus.$emit('loading', false);

                }).catch((error) => { this.loading = false; window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });
            }

            //SE FOR ATIVIDADE COMPLEMENTAR
            if(this.formEnturmacao.tipo_ensino == 3){

                window.eventBus.$emit('loading', true);

                let i = this.$store.state.config.instituicao.id;
                let p = this.$store.state.config.periodo.id;

                this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/turma/getAllTurmasAtividadeComplementar/${i}/${p}`, this.$store.getters.getHeaderAuth).then(response => {

                    this.turmas = response.data;
                    window.eventBus.$emit('loading', false);

                }).catch((error) => { this.loading = false; window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });
            }    
            
            this.defineShowAreasConhecimento();

        },
        getLotacoes(){

            this.loadingLotacoes = true;

            this.filtro.servidor_id = this.dados.id;
            this.filtro.instituicao_id = (this.$store.state.user.tipo <= 3) ? this.$store.state.config.instituicao.id : '';

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/lotacao/getAllByFiltro`, this.filtro, this.$store.getters.getHeaderAuth).then(response => {

                for(let i in response.data){

                    if(response.data[i].funcao == 1 || response.data[i].funcao == 2 || response.data[i].funcao == 3 || response.data[i].funcao == 4 || response.data[i].funcao == 7 || response.data[i].funcao == 8 || response.data[i].funcao == 14){
                        this.dados.professor = true;
                    }

                    if(response.data[i].funcao == 11){
                        this.dados.gestor = true;
                    }
                }

                this.lotacoes = response.data;
                this.loadingLotacoes = false;

            }).catch((error) => { this.$store.commit('throwException', error); });


        },
        getEnturmacao(){

            this.loadingEnturmacao = true;

            this.filtroEnturmacao.periodo_letivo_id = this.$store.state.config.periodo.id;
            this.filtroEnturmacao.servidor_id = this.dados.id;
            this.filtroEnturmacao.instituicao_id = (this.$store.state.user.tipo <= 3) ? this.$store.state.config.instituicao.id : '';

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/enturmacao-professor/getAllByFiltro`, this.filtroEnturmacao, this.$store.getters.getHeaderAuth).then(response => {

                this.enturmacao = response.data;
                this.loadingEnturmacao = false;

            }).catch((error) => { this.$store.commit('throwException', error); });


        },
        onSubmitServidor(){

            document.getElementById("btn-servidor").focus();

            this.$refs.dados.validate((valid) =>{ if(valid){

                let duplicidadePos = false;
                for(let s in this.dados.pos_graduacao){

                    for(let i in this.dados.pos_graduacao){

                        if( this.dados.pos_graduacao[s].ano_pos_graduacao == this.dados.pos_graduacao[i].ano_pos_graduacao &&
                            this.dados.pos_graduacao[s].area_pos_graduacao == this.dados.pos_graduacao[i].area_pos_graduacao &&
                            this.dados.pos_graduacao[s].tipo_pos_graduacao == this.dados.pos_graduacao[i].tipo_pos_graduacao &&
                            s != i ){

                            duplicidadePos = true;
                        }
                    }
                }

                if(duplicidadePos){
                    window.eventBus.$emit('alert', {msg: 'Existe duplicidade na pós-graduação.', type: 'warning'});
                    return;
                }

                window.eventBus.$emit('loading', true);

                if(this.editServidor){

                    this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/servidor/update/` + this.dados.id, this.dados, this.$store.getters.getHeaderAuth).then(async response => {

                        if(this.fotoFile){ await this.uploadFotoIfNeeded(this.dados.id); }

                        window.eventBus.$emit('loading', false);
                        window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});

                        this.$emit('onSubmitServidor');

                    }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

                }else{

                    this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/servidor/store`, this.dados, this.$store.getters.getHeaderAuth).then(async response => {

                        if(typeof response.data.throw !== 'undefined'){

                            window.eventBus.$emit('loading', false);
                            window.eventBus.$emit('alert', {msg: response.data.throw.msg, type: response.data.throw.type});

                        }else{

                            // Envia os anexos selecionados durante o cadastro novo, já vinculados ao id criado.
                            if(response.data.id && this.$refs.anexos){
                                await this.$refs.anexos.vincularPendentes(response.data.id);
                            }

                            // Upload da foto (se selecionada), após o servidor já ter id.
                            if(response.data.id && this.fotoFile){
                                await this.uploadFotoIfNeeded(response.data.id);
                            }

                            window.eventBus.$emit('loading', false);
                            window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});

                            this.$emit('onSubmitServidor');
                        }

                    }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

                }

            }else{
                window.eventBus.$emit('alert', {msg: 'Campos obrigatórios não foram preenchidos.', type: 'warning'});
            }});
        },
        formatData(field, size = null){

            //TRATA OS INPUTS - LETRA MAIÚCULA

            if(!this.dados[field])
                return false;

            if(size && this.dados[field].length < size)
                this.dados[field] = '';

            this.dados[field] = this.dados[field].toUpperCase();

            this.dados[field] = this.tratarAcento(this.dados[field]);
        },
        tratarAcento(valor){
        //MANTÉM A ACENTUAÇÃO SE A INSTITUIÇÃO PERMITIR; SENÃO, REMOVE

            if(this.acentuacaoInstituicao)
                return valor;

            return this.$removerAcentos(valor);
        },
        carregarAcentuacaoInstituicao(instituicaoId){
        //BUSCA A CONFIG DE ACENTUAÇÃO DE SERVIDOR DA INSTITUIÇÃO ATIVA (parametros_sistema, por instituição)

            if(!instituicaoId)
                return;

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/parametro-sistema/getValor/servidor.permite_acentuacao?instituicao_id=` + instituicaoId, this.$store.getters.getHeaderAuth).then(response => {

                const valor = response.data && response.data.valor;
                this.acentuacaoInstituicao = (valor === true || valor === '1' || valor === 1 || valor === 'true');

            }).catch((error) => { this.$store.commit('throwException', error); });
        },
        showSearchMunNascimento(){

            this.searchCidade = true;
        },
        showSearchEndereco(){

            this.searchEndereco = true;
        },
        emitMunNascimento(municipio_nascimento){

            this.searchCidade = false;
            this.dados.municipio_nascimento = municipio_nascimento;
            this.dados.municipio_nascimento_id = municipio_nascimento.id;
        },
        emitEndereco(endereco){

            this.searchEndereco = false;
            this.dados.cep = endereco.cep;
            this.dados.logradouro = endereco.logradouro.nome;
            this.dados.bairro = endereco.bairro.nome;
            this.dados.cidade = endereco.cidade;
            this.dados.cidade_id = endereco.cidade.id;
        },
        async buscarViaCep(){

            const cepLimpo = this.dados.cep.replace(/\D/g, '');
            if(cepLimpo.length !== 8 || this.buscandoCep) return;

            this.buscandoCep = true;

            try {
                const { data } = await this.$axios.get(`https://viacep.com.br/ws/${cepLimpo}/json/`);

                if(data.erro){
                    this.limparEndereco();
                    window.eventBus.$emit('alert', { msg: 'Atenção! CEP não encontrado.', type: 'warning' });
                    return;
                }

                this.dados.logradouro = data.logradouro ? this.tratarAcento(data.logradouro.toUpperCase()) : '';
                this.dados.bairro = data.bairro ? this.tratarAcento(data.bairro.toUpperCase()) : '';
                this.dados.cidade.nome = data.localidade ? this.tratarAcento(data.localidade.toUpperCase()) : '';
                this.dados.cidade.id = data.ibge ? data.ibge : '';
                this.dados.cidade_id = data.ibge ? data.ibge : '';

            } catch(error) {
                this.limparEndereco();
                window.eventBus.$emit('alert', { msg: 'Atenção! Erro ao buscar CEP.', type: 'warning' });
            } finally {
                this.buscandoCep = false;
            }
        },
        limparEndereco(){
            this.dados.logradouro = '';
            this.dados.bairro = '';
            this.dados.cidade = { id: '', nome: '', estado: { id: '', nome: '' } };
            this.dados.cidade_id = '';
        },
        changeNacionalidade(){

            if(this.dados.nacionalidade == 1){

                this.dados.pais_id = 1;

                setTimeout(()=>{

                    this.showSearchMunNascimento();

                }, 500);

            }else if(this.dados.nacionalidade == 2){

                this.dados.pais_id = 1;

                this.dados.municipio_nascimento_id = '';
                this.dados.municipio_nascimento = { id: '', nome: '' };

            }else if(this.dados.nacionalidade == 3){

                this.dados.pais_id = '';
                this.dados.pais.id = '';
                this.dados.pais.nome = '';

                this.dados.municipio_nascimento_id = '';
                this.dados.municipio_nascimento.id = '';
                this.dados.municipio_nascimento.nome = '';
            }

        },
        initFormServidor(){

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/servidor/initFormServidor`, this.$store.getters.getHeaderAuth).then(response => {

                this.selectDeficiencias = response.data.deficiencias;
                this.paises = response.data.paises;

            }).catch((error) => { this.$store.commit('throwException', error); });

        },
        showDialogLotacao(lotacao){

            if(!this.dados.nome){

                window.eventBus.$emit('alert', {msg: 'É necessário informar o nome do servidor antes de criar uma lotação.', type: 'warning'});
                return false;
            }

            if(lotacao){

                this.formLotacao = JSON.parse(JSON.stringify(lotacao));
                this.formLotacao.data_lotacao = this.$moment(this.formLotacao.data_lotacao).format('DD/MM/YYYY');
                this.editLotacao = true;

                this.instituicoesLotacao = [{id: this.formLotacao.instituicao.id, nome: this.formLotacao.instituicao.nome}];

            }else{

                if(this.$store.state.user.tipo <= 3){

                    this.instituicoesLotacao = [{id: this.$store.state.config.instituicao.id, nome: this.$store.state.config.instituicao.nome}];

                }else{

                    this.instituicoesLotacao = this.$store.state.instituicoes;
                }

                this.formLotacao.data_lotacao = this.$moment().format('DD/MM/YYYY');
                this.editLotacao = false;
            }

            this.dialogLotacao = true;
        },
        onSubmitFormLotacao(){

            document.getElementById("btn-servidor").focus();

            if(!this.editServidor){

                this.dados.lotacoes.push(this.formLotacao);
                this.dialogLotacao = false;
                return false;
            }

            this.$refs.formLotacao.validate((valid) =>{ if(valid){

                window.eventBus.$emit('loading', true);

                if(this.editLotacao){

                    this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/lotacao/update/` + this.formLotacao.id, this.formLotacao, this.$store.getters.getHeaderAuth).then(response => {

                        if(typeof response.data.throw !== 'undefined'){

                            window.eventBus.$emit('loading', false);
                            window.eventBus.$emit('alert', {msg: response.data.throw.msg, type: response.data.throw.type});

                        }else{

                            window.eventBus.$emit('loading', false);
                            window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                            this.getLotacoes();
                            this.getEnturmacao();

                            this.dialogLotacao = false;
                        }

                    }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

                }else{

                    this.formLotacao.servidor_id = this.dados.id;
                    this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/lotacao/store`, this.formLotacao, this.$store.getters.getHeaderAuth).then(response => {

                        if(typeof response.data.throw !== 'undefined'){

                            window.eventBus.$emit('loading', false);
                            window.eventBus.$emit('alert', {msg: response.data.throw.msg, type: response.data.throw.type});

                        }else{

                            window.eventBus.$emit('loading', false);
                            window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                            this.getLotacoes();

                            this.dialogLotacao = false;
                        }

                    }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

                }

            }else{
                window.eventBus.$emit('alert', {msg: 'Campos obrigatórios não foram preenchidos.', type: 'warning'});
            }});

        },
        showDialogRemocao(id){

            this.formRemocao.id = id;
            this.formRemocao.data_remocao = this.$moment().format('DD/MM/YYYY');
            this.dialogRemocao = true;
        },
        onSubmitFormRemocao(){

            this.$msgbox.confirm('Tem certeza que deseja realizar a remoção deste servidor?', 'Atenção', { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' }).then(() => {

                window.eventBus.$emit('loading', true);

                this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/lotacao/remover`, this.formRemocao, this.$store.getters.getHeaderAuth).then(response => {

                    window.eventBus.$emit('loading', false);
                    window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                    this.getLotacoes();
                    this.getEnturmacao();

                    this.dialogRemocao = false;

                }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

            }).catch(()=>{});
        },
        removerLotacao(i){

            this.dados.lotacoes.splice(i, 1);
        },
        resetForm(){

            this.dados = {
                id: '',
                nome: '',
                nome_censo: '',
                lote: '',
                matricula: '',
                tipo: '',
                cargo: '',
                criterio_escolha_cargo: '',
                situacao_funcional: '',
                termino_contrato: '',
                inep: '',
                pis_pasep: '',
                rg: '',
                data_emissao_rg: '',
                orgao_emissor_rg: '',
                uf_rg: '',
                cpf: '',
                data_nascimento: '',
                mae: '',
                pai: '',
                sexo: '',
                cor: '',
                logradouro: '',
                numero: '',
                bairro: '',
                cep: '',
                complemento: '',
                localizacao_zona: '',
                nacionalidade: '',
                localizacao_diferenciada: '',
                email: '',
                telefone: '',
                celular: '',
                celular_outro: '',
                observacao: '',
                situacao: '',
                escolaridade: '',
                tipo_ensino_medio: '',
                tipo_ensino_cursado: '',
                pos_graduacao: '',
                data_ingresso_prefeitura: '',
                pais_id: '',
                municipio_nascimento_id: '',
                cidade_id: '',
                cidade: {
                    id: '',
                    nome: '',
                    estado: {
                        id: '',
                        nome: ''
                    }
                },
                pais: {
                    id: '',
                    nome: ''
                },
                municipio_nascimento: {
                    id: '',
                    nome: ''
                },
            };

            this.$refs.dados.clearValidate();
        },
        resetFormLotacao(){

            this.formLotacao = {
                id: '',
                data_lotacao: '',
                observacao: '',
                instituicao_sede: '',
                instituicao_id: '',
                servidor_id: '',
                funcao: '',
                categoria: ''
            };
        },
        resetFormRemocao(){

            this.formRemocao = { id: '', data_remocao: '' };
        },
        resetFormEnturmacao(){

            this.formEnturmacao = {
                servidor_id: '',
                turma_id: '',
                areas_conhecimento: []
            };
        },
        changeLotacaoFormEnturmacao(){

            for(let i in this.lotacoesForEnturmacao){

                if(this.lotacoesForEnturmacao[i].id == this.formEnturmacao.lotacao_id){
                    this.formEnturmacao.lotacao_funcao = this.lotacoesForEnturmacao[i].funcao;
                }
            }

            if(this.formEnturmacao.lotacao_funcao == 3){
                this.formEnturmacao.tipo_ensino = '';
            }

            this.defineShowAreasConhecimento();

        },
        defineShowAreasConhecimento() { //aqui

            //DOCENTE ou MONITOR && REGULAR
            if((this.formEnturmacao.lotacao_funcao == 1 || this.formEnturmacao.lotacao_funcao == 3) && this.formEnturmacao.tipo_ensino == 1) {
                this.showAreasConhecimento = true;
            } else {
                this.showAreasConhecimento = false;
            }

            for(let i in this.turmas){

                for(let j in this.turmas[i]){

                    if(this.turmas && this.turmas[i] && this.turmas[i][j] && this.turmas[i][j].id == this.formEnturmacao.turma_id){

                        if( 
                            this.turmas[i][j].curso_id == 1179 || //Creche 2 Anos
                            this.turmas[i][j].curso_id == 1147 || //Creche 3 Anos
                            this.turmas[i][j].curso_id == 1181 || //Educação Infantil - 04 Anos
                            this.turmas[i][j].curso_id == 1159 || //Educação Infantil - 05 Anos
                            this.turmas[i][j].curso_id == 110  || //Pré-escola (4 e 5 anos)
                            this.turmas[i][j].curso_id == 111  || //Creche (0 a 3 anos) 
                            this.turmas[i][j].curso_id == 1488  || //Multi - Maternal I E II
                            this.turmas[i][j].curso_id == 1489  || //Multi - Pre I e II
                            this.turmas[i][j].curso_id == 1490  || //Multi - Pre II e 1º Ano
                            this.turmas[i][j].curso_id == 1491  || //Multi - Pre I ao 5º Ano
                            this.turmas[i][j].curso_id == 1492  || //Multi - Pre I ao 1º Ano
                            this.turmas[i][j].curso_id == 1493  || //Multi - Pre I ao 2º Ano
                            this.turmas[i][j].curso_id == 1494  || //Multi - Creche 2 Anos ao 1º Ano
                            this.turmas[i][j].curso_id == 1495  || //Multi - Creche 2 Anos ao 2º Ano
                            this.turmas[i][j].curso_id == 1496     //Multi - Pre I a Creche 2 Anos
                        ){
                            this.showAreasConhecimento = false;
                        }
                    }
                }
            }

        },
        getLotacaoForStoreEnturmacao(){

            let i = this.$store.state.config.instituicao.id;
            return this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/lotacao/getLotacaoForStoreEnturmacao/` + i + '/' + this.dados.id, this.$store.getters.getHeaderAuth);

        },
        onSubmitFormEnturmacao(){

            this.$refs.formEnturmacao.validate((valid) =>{ if(valid){

                window.eventBus.$emit('loading', true);

                this.formEnturmacao.servidor_id = this.dados.id;
                this.formEnturmacao.periodo_letivo_id = this.$store.state.config.periodo.id

                this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/enturmacao-professor/store`, this.formEnturmacao, this.$store.getters.getHeaderAuth).then(response => {

                    if(typeof response.data.throw !== 'undefined'){

                        window.eventBus.$emit('loading', false);
                        window.eventBus.$emit('alert', {msg: response.data.throw.msg, type: response.data.throw.type});

                    }else{

                        window.eventBus.$emit('loading', false);
                        window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                        this.getEnturmacao();

                        this.dialogEnturmacao = false;
                    }

                }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

            }else{
                window.eventBus.$emit('alert', {msg: 'Campos obrigatórios não foram preenchidos.', type: 'warning'});
            }});

        },
        getDisciplinasByServidor(){

            return this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/servidor/getAreasConhecimentoByServidor/` + this.dados.id, this.$store.getters.getHeaderAuth);

        },
        getTurmas(){

            window.eventBus.$emit('loading', true);

            this.formEnturmacao.turma_id = '';

            let i = this.$store.state.config.instituicao.id;
            let p = this.$store.state.config.parametros.periodo_letivo_situacao_academica;

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/turma/getAllTurmas/${i}/${p}`, this.$store.getters.getHeaderAuth).then(response => {

                this.turmas = response.data;
                window.eventBus.$emit('loading', false);

            }).catch((error) => { this.loading = false; window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

        },
        deleteEnturmacao(item){

            this.$msgbox.confirm('Tem certeza que deseja excluir esta enturmação?', 'Atenção', { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' }).then(() => {

                window.eventBus.$emit('loading', true);

                this.$axios.delete(`${this.$store.state.config.baseUrlApi}/api/enturmacao-professor/delete/${item.disciplina.id}/${item.id}`, this.$store.getters.getHeaderAuth).then(response => {

                    window.eventBus.$emit('loading', false);
                    window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                    this.getEnturmacao();

                }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

            }).catch(()=>{});
        },
        getAllDisciplinas(){

            return this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/area-conhecimento/getAll`, this.$store.getters.getHeaderAuth);
        },
        showDialogDisciplina(){

            this.$axios.all([this.getAllDisciplinas(), this.getDisciplinasByServidor()]).then(this.$axios.spread((disciplinas, disciplinasServidor)=>{

                this.disciplinas = disciplinas.data;

                for(let i in disciplinasServidor.data){

                    this.formDisciplina.disciplinas.push(disciplinasServidor.data[i].id);
                }

                this.dialogDisciplina = true;

            })).catch((error) => { this.$store.commit('throwException', error); });

        },
        onSubmitFormDisciplina(){

            this.$refs.formDisciplina.validate((valid) =>{ if(valid){

                window.eventBus.$emit('loading', true);

                this.formDisciplina.servidor_id = this.dados.id;

                this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/servidor/storeAreaConhecimentoServidor`, this.formDisciplina, this.$store.getters.getHeaderAuth).then(response => {

                    if(typeof response.data.throw !== 'undefined'){

                        window.eventBus.$emit('loading', false);
                        window.eventBus.$emit('alert', {msg: response.data.throw.msg, type: response.data.throw.type});

                    }else{

                        window.eventBus.$emit('loading', false);
                        window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                        this.dialogDisciplina = false;

                        this.loadingDisciplina = true;
                        this.getDisciplinasByServidor().then(response => {

                            this.loadingDisciplina = false;
                            this.disciplinasServidor = response.data;

                        }).catch((error) => { this.$store.commit('throwException', error); });
                    }

                }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

            }else{
                window.eventBus.$emit('alert', {msg: 'Campos obrigatórios não foram preenchidos.', type: 'warning'});
            }});
        },
        resetFormDisciplina(){

            this.formDisciplina = {
                disciplinas: [],
                servidor_id: ''
            };
        },
        getFormacao(){

            this.loadingFormacao = true;

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/servidor/getFormacaoServidor/` + this.dados.id, this.$store.getters.getHeaderAuth).then(response => {

                this.formacao = response.data;
                this.loadingFormacao = false;

            }).catch((error) => { this.$store.commit('throwException', error); });

        },
        showDialogFormacao(item){

            this.instituicoes = [];
            this.cursos = [];

            if(item){

                this.formFormacao = item;
                this.instituicoes.push(item.ensino_superior_instituicao);
                this.cursos.push(item.ensino_superior_curso);
                this.editFormacao = true;
            }

            this.dialogFormacao = true;
        },
        searchInstituicaoSuperior(query){

            if (query.length < 2){

                this.instituicoes = [];
                return false;
            }

            query = this.$removerAcentos(query);

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/ensino-superior-instituicao/searchByNome`, {query: query}, this.$store.getters.getHeaderAuth).then(response => {

                this.instituicoes = JSON.parse(JSON.stringify(response.data));

            }).catch((error) => { this.$store.commit('throwException', error); });

        },
        searchCursoSuperior(query){

            if (query.length < 2){

                this.cursos = [];
                return false;
            }

            query = this.$removerAcentos(query);

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/ensino-superior-curso/searchByNome`, {query: query}, this.$store.getters.getHeaderAuth).then(response => {

                this.cursos = JSON.parse(JSON.stringify(response.data));

            }).catch((error) => { this.$store.commit('throwException', error); });

        },
        onSubmitFormFormacao(){

            this.$refs.formFormacao.validate((valid) =>{ if(valid){

                window.eventBus.$emit('loading', true);

                if(this.editFormacao){

                    this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/servidor/updateFormacaoServidor/` + this.formFormacao.id, this.formFormacao, this.$store.getters.getHeaderAuth).then(response => {

                        if(typeof response.data.throw !== 'undefined'){

                            window.eventBus.$emit('loading', false);
                            window.eventBus.$emit('alert', {msg: response.data.throw.msg, type: response.data.throw.type});

                        }else{

                            window.eventBus.$emit('loading', false);
                            window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                            this.dialogFormacao = false;
                            this.getFormacao();
                        }

                    }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

                }else{

                    this.formFormacao.servidor_id = this.dados.id;

                    this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/servidor/storeFormacaoServidor`, this.formFormacao, this.$store.getters.getHeaderAuth).then(response => {

                        if(typeof response.data.throw !== 'undefined'){

                            window.eventBus.$emit('loading', false);
                            window.eventBus.$emit('alert', {msg: response.data.throw.msg, type: response.data.throw.type});

                        }else{

                            window.eventBus.$emit('loading', false);
                            window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                            this.dialogFormacao = false;
                            this.getFormacao();
                        }

                    }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

                }

            }else{
                window.eventBus.$emit('alert', {msg: 'Campos obrigatórios não foram preenchidos.', type: 'warning'});
            }});
        },
        resetFormFormacao(){

            this.formFormacao = {
                ano_inicio: '',
                ano_conclusao: '',
                situacao: '',
                carga_horaria: '',
                numero_pontos: '',
                complementacao: false,
                ensino_superior_curso_id: '',
                ensino_superior_instituicao_id: '',
                servidor_id: ''
            };

        },
        getCursosComplementares(){

            this.loadingCursosComplementares = true;

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/servidor/getCursosComplementaresServidor/` + this.dados.id, this.$store.getters.getHeaderAuth).then(response => {

                this.cursosComplementares = response.data;
                this.loadingCursosComplementares = false;

            }).catch((error) => { this.$store.commit('throwException', error); });

        },
        showDialogCursosComplementares(){

            window.eventBus.$emit('loading', true);

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/curso-complementar/getAll`, this.$store.getters.getHeaderAuth).then(response => {

                window.eventBus.$emit('loading', false);

                for(let i in this.cursosComplementares){

                    this.formCursosComplementares.cursos.push(this.cursosComplementares[i].id);
                }

                this.selectCursosComplementares = response.data;
                this.dialogCursosComplementares = true;

            }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

        },
        onSubmitFormCursosComplementares(){

            this.$refs.formCursosComplementares.validate((valid) =>{ if(valid){

                window.eventBus.$emit('loading', true);

                this.formCursosComplementares.servidor_id = this.dados.id;

                    this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/servidor/storeCursosComplementaresServidor`, this.formCursosComplementares, this.$store.getters.getHeaderAuth).then(response => {

                        if(typeof response.data.throw !== 'undefined'){

                            window.eventBus.$emit('loading', false);
                            window.eventBus.$emit('alert', {msg: response.data.throw.msg, type: response.data.throw.type});

                        }else{

                            window.eventBus.$emit('loading', false);
                            window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                            this.dialogCursosComplementares = false;
                            this.getCursosComplementares();
                        }

                    }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

            }else{
                window.eventBus.$emit('alert', {msg: 'Campos obrigatórios não foram preenchidos.', type: 'warning'});
            }});

        },
        resetFormCursoComplementar(){

            this.formCursosComplementares = {
                cursos: []
            };
        }

    },
    watch: {
        paramId: {
            immediate: true,
            handler (value) {

                if(value){

                    this.getServidorById(value);
                    this.editServidor = true;
                }
            }
        },
        'dados.situacao_funcional': function(newVal, oldVal){

           if(newVal == 2){

               this.dados.termino_contrato = '';
           }

        }
    },
    components:{ searchCidade, searchEndereco, anexos, InputImage }
}
</script>
